{
	"content": {
		"declarationDetailsSection": {
			"title": "Szczegóły deklaracji",
			"description": "Aby utworzyć deklarację, wymagane są: nazwa klienta, adres oraz kraj posiadacza deklaracji. Tych informacji nie można później zmienić.",
			"customerLabel": "Konto klienta"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Wprowadź szczegóły deklaracji",
			"alertDescription": "Podane informacje zostaną trwale zapisane na deklaracji i nie będzie można ich później zmodyfikować.",
			"projectLabel": "Odniesienie do projektu",
			"companyNameLabel": "Nazwa firmy",
			"streetLabel": "Ulica",
			"zipCodeLabel": "Kod pocztowy",
			"cityLabel": "Miasto",
			"countryLabel": "Kraj"
		}
	},
	"summary": {
		"title": "Podsumowanie",
		"declarationTypeTitle": "Typ deklaracji",
		"customerProjectTitle": "Projekt klienta",
		"internalProjectOrProductTitle": "Projekt / produkt wewnętrzny",
		"projectReferenceTitle": "Odniesienie do projektu",
		"materialHeaderTitle": "Materiał",
		"quantityHeaderTitle": "Ilość ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Redukcje emisji CO\u2082 do alokacji ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Redukcja emisji CO\u2082 niepodlegająca alokacji ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Odniesienie do projektu jest wymagane",
		"companyNameRequired": "Nazwa firmy jest wymagana",
		"streetRequired": "Ulica jest wymagana",
		"zipCodeRequired": "Kod pocztowy jest wymagany",
		"cityRequired": "Miasto jest wymagane",
		"countryRequired": "Kraj jest wymagany",
		"customerRequired": "Klient jest wymagany"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Sprawdź podsumowanie deklaracji",
		"description": "Sprawdź wprowadzone dane pod kątem ewentualnych błędów.",
		"alertDescription": "Podane informacje zostaną trwale zapisane na deklaracji i nie będzie można ich później zmodyfikować.",
		"typeSectionTitle": "1. Typ",
		"declarationTypeLabel": "Typ deklaracji",
		"customerProjectTitle": "Projekt klienta",
		"internalProjectOrProductTitle": "Projekt / produkt wewnętrzny",
		"projectReferenceLabel": "Odniesienie do projektu",
		"materialSectionTitle": "2. Materiał",
		"materialHeaderTitle": "Materiał",
		"quantityHeaderTitle": "Ilość ({{unit}})",
		"totalCarbonReductionsLabel": "Całkowite redukcje emisji CO₂ ({{unit}})",
		"declarationSectionTitle": "3. Deklaracja",
		"companyNameLabel": "Nazwa firmy",
		"streetLabel": "Ulica",
		"zipCodeLabel": "Kod pocztowy",
		"cityLabel": "Miasto",
		"countryLabel": "Kraj",
		"backTitle": "Wstecz",
		"submitTitle": "Tak, wszystko się zgadza"
	},
	"submitTitle": "Utwórz deklarację",
	"backTitle": "Wstecz"
}
